export const mapStyle = "https://basemaps.cartocdn.com/gl/positron-nolabels-gl-style/style.json";
